import { message } from 'antd';
import {
  fetchAreaExecutionAreaTypeEnum,
  fetchAreaExecutionBatchUpdateDistance,
  fetchAreaExecutionDistanceConfigList,
  fetchAreaExecutionExport,
  fetchAreaExecutionExportDistanceConfig,
  fetchAreaExecutionFinalEffect,
  fetchAreaExecutionImport,
  fetchAreaExecutionPage,
  fetchAreaExecutionUpdateDistance,
} from '@/services/cityToCityAreaExecution';

const normalizeDistanceConfig = (item = {}) => {
  const w1MaxDistance = item?.w1MaxDistance || 50;
  const w2MaxDistance = item?.w2MaxDistance || 100;
  return {
    ...item,
    w1ReceiveMaxDistance: item?.w1ReceiveMaxDistance || w1MaxDistance,
    w2ReceiveMaxDistance: item?.w2ReceiveMaxDistance || w2MaxDistance,
    w1MaxDistance,
    w2MaxDistance,
  };
};

export default {
  namespace: 'areaExecutionTable',
  state: {
    searchParams: {},
    list: [],
    total: 0,
    areaTypeConfigList: [],
    areaTypeEnum: [],
  },

  effects: {
    // 最终生效配置保存：后端 updateExecutionHours 为单条接口，payload 为单条编辑结果对象，直接透传。
    *saveFinalEffect({ payload }, { call }) {
      const result = yield call(fetchAreaExecutionFinalEffect, payload);
      if (result?.code === 1) {
        message.success(result?.message || '保存成功');
      }
      return result;
    },
    *fetchList({ payload }, { call, put }) {
      const result = yield call(fetchAreaExecutionPage, payload);
      yield put({
        type: 'updateState',
        payload: {
          searchParams: payload || {},
          list: result?.data?.rows || [],
          total: result?.data?.total || 0,
        },
      });
    },
    *fetchAreaTypeEnum(_, { call, put }) {
      const result = yield call(fetchAreaExecutionAreaTypeEnum);
      yield put({
        type: 'updateState',
        payload: {
          areaTypeEnum: result?.data || [],
        },
      });
      return result;
    },
    *fetchAreaTypeConfigList(_, { call, put, select }) {
      const result = yield call(fetchAreaExecutionDistanceConfigList);
      const currentConfigList = yield select(
        (state) => state.areaExecutionTable.areaTypeConfigList,
      );
      // 后端未返回配置时，继续沿用当前配置。
      const nextList =
        Array.isArray(result?.data) && result.data.length > 0
          ? result.data.map(normalizeDistanceConfig)
          : (currentConfigList || []).map(normalizeDistanceConfig);
      yield put({
        type: 'updateState',
        payload: {
          areaTypeConfigList: nextList,
        },
      });
      return result;
    },
    *batchUpdateDistance({ payload }, { call }) {
      const result = yield call(fetchAreaExecutionBatchUpdateDistance, payload);
      if (result?.code === 1) {
        message.success(result?.message || '保存成功');
      }
      return result;
    },
    *updateDistance({ payload }, { call }) {
      const result = yield call(fetchAreaExecutionUpdateDistance, payload);
      if (result?.code === 1) {
        message.success(result?.message || '保存成功');
      }
      return result;
    },
    *exportData({ payload }, { call }) {
      return yield call(fetchAreaExecutionExport, payload);
    },
    *exportDistanceConfig(_, { call }) {
      return yield call(fetchAreaExecutionExportDistanceConfig);
    },
    *importData({ payload }, { call }) {
      return yield call(fetchAreaExecutionImport, payload);
    },
  },

  reducers: {
    updateState(state, { payload }) {
      return { ...state, ...payload };
    },
  },
};
